import { createStyles, Drawer, makeStyles, Theme } from '@material-ui/core';
import clsx from 'clsx';
import React from 'react';

export type MultiSlotDrawerProps = React.PropsWithChildren<{
    open: boolean;
    hideBackdrop?: boolean;
    onClose: () => void;
}>;

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            '& .MuiDrawer-paperAnchorRight': {
                width: '100%',

                [theme.breakpoints.up('md')]: {
                    width: 590
                }
            }
        },
        passThrough: {
            // Without its backdrop the modal root still swallows clicks meant for whatever
            // sits underneath it, so only the paper stays interactive.
            'pointerEvents': 'none',

            '& .MuiDrawer-paper': {
                pointerEvents: 'auto'
            }
        },
        wrapper: {
            width: '100%',
            height: '100%',
            display: 'flex',
            flexDirection: 'column',
            overflow: 'hidden'
        }
    })
);

export const MultiSlotDrawer: React.FC<MultiSlotDrawerProps> = props => {
    const classes = useStyles();

    return (
        <Drawer
            anchor="right"
            open={props.open}
            onClose={props.onClose}
            hideBackdrop={props.hideBackdrop}
            className={clsx(classes.root, { [classes.passThrough]: props.hideBackdrop })}
        >
            <div className={classes.wrapper}>{props.children}</div>
        </Drawer>
    );
};
